// 使用与main.js相同的Vue版本（完整版，包含编译器）
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);


// 配置路由
const routes = [
  { name: 'home', path: '/', component: (resolve) => require(['../view/index.vue'], resolve), meta: { title: '易协同工作台' } },
  { name: 'login', path: '/login', component: (resolve) => require(['../view/login.vue'], resolve), meta: { title: '工作台登录' } },
	{ name: 'inpage', path: '/inpage', component: (resolve) => require(['../view/inpage.vue'], resolve), meta: { title: '登录中' } },
	{ name: 'map', path: '/map', component: (resolve) => require(['../view/map.vue'], resolve), meta: { title: '地图' } },
  { name: 'notlogin', path: '/notlogin', component: (resolve) => require(['../view/notlogin.vue'], resolve), meta: { title: '登录中' } },
  { name: 'wxlogin', path: '/wxlogin', component: (resolve) => require(['../view/wxlogin.vue'], resolve), meta: { title: '企业微信登录中' } },
  { name: 'tree', path: '/tree', component: (resolve) => require(['../view/tree.vue'], resolve), meta: { title: '目标视图切换' } },
  { name: 'file', path: '/file', component: (resolve) => require(['../view/file.vue'], resolve), meta: { title: '文件管理' } },
  { name: 'task', path: '/task', component: (resolve) => require(['../view/task.vue'], resolve), meta: { title: 'AI新增任务'} },
  { name: 'taskcj', path: '/taskcj', component: (resolve) => require(['../view/task/index.vue'], resolve), meta: { title: '新增任务'} },
  { name: 'test', path: '/test', component: (resolve) => require(['../view/test/index.vue'], resolve), meta: { title: '测试'} },
  { name: 'canvaseditor', path: '/canvaseditor', component: (resolve) => require(['../view/CanvasEditor.vue'], resolve), meta: { title: 'canvas编辑器'} },
  { name: 'scheduling', path: '/scheduling', component: (resolve) => require(['../customize/scheduling/index.vue'], resolve), meta: { title: '排班'} },
  { name: 'desktopStatistics', path: '/desktopStatistics', component: (resolve) => require(['../view/DesktopStatistics/index.vue'], resolve), meta: { title: '桌面统计'} },
  { name: 'codeEditor', path: '/codeEditor', component: (resolve) => require(['../view/CodeEditor/index.vue'], resolve), meta: { title: '代码编辑器'} },
  { name: 'test2', path: '/test2', component: (resolve) => require(['../view/test.vue'], resolve), meta: { title: '测试页面2'} },
  {
    path: '/scheduling/detail',
    name: 'ScheduleDetail',
    component: () => import('@/customize/scheduling/detail'),
    meta: {
      title: '排班详情'
    }
  }
];

// 创建路由实例
const router = new Router({
	// mode: 'history',
  routes,
});

// 免登录页面名单
const whiteList = ['task', 'taskcj', 'scheduling', 'ScheduleDetail', 'notlogin', 'inpage', 'codeEditor', 'wxlogin'];

// 路由后置钩子 - 页面滚动到顶部
router.afterEach(() => {
  window.scrollTo(0, 0);
});

// 路由前置守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  
  const corpId = to.query.corpId;
  const isLogin = window.localStorage.getItem('gzt_uid');
  
  // 判断是否是免登录页面
  if (whiteList.includes(to.name)) {
    return next(); // 免登页面直接放行
  }
  
  // 有corpId参数也放行
  if (corpId) {
    return next();
  }
  
  // 未登录且目标不是登录页，则跳转到登录页
  if (!isLogin && to.name !== 'login') {
    return next({ name: 'login' });
  }
  
  // 已登录且目标是登录页，则跳转到首页
  if (isLogin && to.name === 'login') {
    return next({ name: 'home' });
  }
  
  // 其他情况正常放行
  next();
});

export default router;
